/* eslint-disable */
export const ORDER_PERSIST_KEY = `bds:order`;

export const ORDER_STATUS_CANCELLED = `106`;
export const ORDER_STATUS_COMPLETED = `105`;
export const ORDER_STATUS_CONFIRMED = `102`;
export const ORDER_STATUS_DELIVERING = `103`;
export const ORDER_STATUS_ON_HOLD = `104`;
export const ORDER_STATUS_TO_BE_CONFIRMED = `101`;
export const ORDER_STATUS_NEW = `100`;
export const ORDER_STATUS_NONE = `0`;

export const ORDER_QUANTITY_METER_CUBIC = `M3`;

export const ORDER_API_DATE_FORMAT = `YYYYMMDD`;
export const ORDER_MAX_DAYS_FROM_TODAY = 90;

export const ORDER_CONFIRM_CUTOFF_TIME = `15:00:00`;
export const ORDER_CONFIRM_CUTOFF_DAYS_FROM_TODAY = -1;

export const ORDER_CANCEL_CUTOFF_TIME = `13:00:00`;
export const ORDER_CANCEL_CUTOFF_DAYS_FROM_TODAY = -1;

export const DUMMY_NOTIFICATION_FOR_TESTING_CONFIG_DESCRIPTION = `Some description for this notification`;
export const DUMMY_NOTIFICATION_FOR_TESTING_CONFIG_HEADLINE = `Headline for this dummy notification`;

export const ORDER_ALREADY_PLACED_ON_THIS_DEVICE = `ORDER_ALREADY_PLACED_ON_THIS_DEVICE`;
export const ORDER_EDIT_INFO_ALREADY_CONFIRMED_ON_THIS_DEVICE = `ORDER_EDIT_INFO_ALREADY_CONFIRMED_ON_THIS_DEVICE`;
export const ORDER_EDIT_DATE_INFO_ALREADY_CONFIRMED_ON_THIS_DEVICE = `ORDER_EDIT_DATE_INFO_ALREADY_CONFIRMED_ON_THIS_DEVICE`;

export const APPLIED = `APPLIED`;
export const SUBMITTED = `SUBMITTED`;
